/**
 * Item reducer
 */

import _merge from "lodash/merge";
import { Repo } from "@thenounproject/lingo-core";

export const getShortIdsFromEntities = Repo.getShortIdsFromEntities;

const shortIdReducer = (state = {}, action) => {
  if (!action.response) return state;
  const entities = action.response.entities;
  if (!entities) return state;

  const updates = getShortIdsFromEntities(entities);
  return _merge({}, state, updates);
};

export default shortIdReducer;
